export default __webpack_public_path__ + "static/media/align_horizontal_center-B.af29d1ae.svg";